<template>
  <pl-dialog :disableOutsideClick="true" size="confirm_size" title="Leave Discussion" @close="$emit('close')">
    <div class="flex flex-col h-full py-4 px-6">
      <div class="flex flex-grow h-full">
        
      </div>
      <div class="flex items-center justify-between space-x-2">
        <button @click="$emit('close')" class="bg-gray-50 hover:bg-gray-100 w-full border font-poppins border-solid border-gray-200 text-gray-800 rounded py-2 px-4">Stay here!</button>
        <button @click="$emit('confirm_accepted')" class="bg-primary hover:bg-primary-dark w-full border border-solid border-primary text-white rounded py-2 px-4 flex justify-center items-center space-x-2">
          <i class="fa-solid fa-chart-bar"></i>
          <span class="font-poppins">Go to Reports</span>
        </button>
      </div>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';

  export default Vue.extend({
    data() {
      return {
       isEnding: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion']),
    },
  });
</script>


// WEBPACK FOOTER //
// LeaveModal.vue?3863815a